/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { SubjectAreaContent } from 'components';
import { Card, Typography, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  noItems: {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2)
    }
  }
}));

const SubjectAreaContents = props => {
  const { subjectAreaContents, onDelete, overridden } = props;
  const classes = useStyles();

  // Group entries by subject area for display, keeping the position each
  // entry had in the input so onDelete can target the right one on the
  // server (which splices by index into the un-grouped array).
  const groupsByArea = {};
  if (subjectAreaContents) {
    const indexed = subjectAreaContents.map((content, originalIndex) => ({
      content,
      originalIndex
    }));
    indexed.sort((a, b) => {
      if (a.content.subjectArea < b.content.subjectArea) return -1;
      if (a.content.subjectArea > b.content.subjectArea) return 1;
      return 0;
    });
    for (const entry of indexed) {
      const area = entry.content.subjectArea;
      if (!groupsByArea.hasOwnProperty(area)) {
        groupsByArea[area] = [];
      }
      groupsByArea[area].push(entry);
    }
  }

  const areaKeys = Object.keys(groupsByArea);

  return (
    <div>
      {(!subjectAreaContents || subjectAreaContents.length === 0) && (
        <Card>
          <CardContent className={classes.noItems}>
            <Typography variant="body1">No Items</Typography>
          </CardContent>
        </Card>
      )}
      {areaKeys.map((area, i) => (
        <SubjectAreaContent
          key={area}
          onDelete={onDelete}
          subjectArea={area}
          subjectAreaContents={groupsByArea[area].map(e => e.content)}
          originalIndices={groupsByArea[area].map(e => e.originalIndex)}
          overridden={overridden}
          midItem={i + 1 < areaKeys.length}
        />
      ))}
    </div>
  );
};

SubjectAreaContents.propTypes = {
  subjectAreaContents: PropTypes.array
};

export default SubjectAreaContents;
